import type { Phrase } from '../types';
import type { homeEn } from './home.en';

export const homeMl: Partial<Record<keyof typeof homeEn, Phrase>> = {
  // opening intro
  hmIntroTag: 'ഓഡിറ്റോറിയങ്ങൾ · കല്യാണ മണ്ഡപങ്ങൾ · പരിപാടി വേദികൾ',
  hmIntroSkip: 'ഒഴിവാക്കുക',

  // hero
  hmHeroLine1: 'ഇടം കണ്ടെത്തൂ.',
  hmHeroLine2: '*നിമിഷം* ഒരുക്കൂ.',
  hmSlideWeddings: 'വിവാഹങ്ങൾ',
  hmSlideBanquet: 'ബാങ്ക്വറ്റ് ഹാളുകൾ',
  hmSlideConcerts: 'സംഗീത പരിപാടികൾ',
  hmSlideConferences: 'കോൺഫറൻസുകൾ',
  hmSlideReceptions: 'റിസപ്ഷനുകൾ',
  hmSlideShow: '{total}-ൽ {n}-ാം ചിത്രം കാണിക്കുക: {caption}',
  hmSlidePause: 'പശ്ചാത്തല സ്ലൈഡ്ഷോ നിർത്തുക',
  hmSlidePlay: 'പശ്ചാത്തല സ്ലൈഡ്ഷോ തുടരുക',
  hmPause: 'നിർത്തുക',
  hmPlay: 'തുടരുക',

  // search
  hmSearchLabel: 'വേദികൾ തിരയുക',
  hmSearchLocation: 'സ്ഥലം',
  hmSearchAnywhere: 'എവിടെയും',
  hmSearchEvent: 'പരിപാടിയുടെ തരം',
  hmSearchAnyEvent: 'ഏത് പരിപാടിയും',
  hmSearchDate: 'തീയതി',
  hmSearchDatePh: 'ഏത് തീയതിയും',
  hmSearchGuests: 'അതിഥികൾ',
  hmSearchGuestsPh: 'എത്ര പേർ?',
  hmSearchGo: 'വേദികൾ തിരയുക',

  // why
  hmWhyLabel: 'Aghosha-യുടെ ഉറപ്പ്',
  hmWhyNote: 'പരിശോധിച്ചത് · യഥാർത്ഥ തീയതികൾ · ഓൺലൈൻ പേയ്മെന്റ് ഇല്ല',
  hmTrustTitle: 'എന്തുകൊണ്ട് *Aghosha*',
  hmTrust1Title: 'ലിസ്റ്റ് ചെയ്യും മുൻപ് പരിശോധന',
  hmTrust1Body: 'ഓരോ വേദിയുടെയും ലൈസൻസുകളും ഉടമയുടെ ഐഡിയും Aghosha അഡ്മിൻ പരിശോധിച്ച ശേഷമേ അത് പ്രസിദ്ധീകരിക്കൂ.',
  hmTrust2Title: 'യഥാർത്ഥ ലഭ്യത',
  hmTrust2Body: 'അഭ്യർത്ഥന അയയ്ക്കും മുൻപേ ഏതെല്ലാം തീയതികളും സെഷനുകളും ഒഴിവുണ്ടെന്ന് കാണാം.',
  hmTrust3Title: 'ഒരുമിച്ച് താരതമ്യം ചെയ്യാം',
  hmTrust3Body: 'രണ്ട് വേദികൾ ഒരുമിച്ച് വെച്ച് ശേഷി, സൗകര്യങ്ങൾ, നിരക്കുകൾ എന്നിവ ഓരോന്നായി താരതമ്യം ചെയ്യാം.',
  hmTrust4Title: 'ഓൺലൈൻ പേയ്മെന്റ് ഇല്ല',
  hmTrust4Body: 'വേദി നിങ്ങളുടെ അഭ്യർത്ഥന സ്ഥിരീകരിക്കുന്നു, പണം നേരിട്ട് വേദിക്ക് നൽകാം. അറിയിപ്പുകളും SMS-ഉം വഴി വിവരങ്ങൾ ലഭിക്കും.',

  // featured venues
  hmFeatEyebrow: 'തിരഞ്ഞെടുത്ത വേദികൾ',
  hmFeatNote: 'ഫോട്ടോകൾ, ശേഷി, നിരക്കുകൾ ആദ്യമേ',
  hmFeatTitle: '*അടുത്തറിയേണ്ട* വേദികൾ',
  hmFeatSub: 'ഇപ്പോൾ അഭ്യർത്ഥനകൾ സ്വീകരിക്കുന്ന പരിശോധിച്ച വേദികൾ. ഒഴിവുള്ള തീയതികളും മുഴുവൻ നിരക്കുകളും കാണാൻ ഒരു വേദി തുറക്കൂ.',
  hmFeatAll: 'എല്ലാ വേദികളും',
  hmFeatList: 'തിരഞ്ഞെടുത്ത വേദികൾ',
  hmFeatView: 'വേദി കാണുക',
  hmFeatCapacity: 'ശേഷി',
  hmFeatFrom: 'നിരക്ക്',
  hmGuests: { one: '{count} അതിഥി', other: '{count} അതിഥികൾ' },

  // occasions
  hmOccEyebrow: 'അവസരങ്ങൾ',
  hmOccNote: 'വിവാഹനിശ്ചയം മുതൽ കോൺഫറൻസ് വരെ',
  hmOccTitle: '*ഓരോ അവസരത്തിനും* ഒരു വേദി',
  hmOccSub: 'നിങ്ങളുടെ പരിപാടി തിരഞ്ഞെടുക്കൂ: അതിന് യോജിച്ച വേദികളും ബുക്ക് ചെയ്യും മുൻപ് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളും കാണാം.',
  hmOccAll: 'എല്ലാ പരിപാടി തരങ്ങളും',
  hmOccLabel: 'അവസരം',
  hmVenueCount: { one: '{count} വേദി', other: '{count} വേദികൾ' },

  // statement
  hmPromoEyebrow: 'പ്രധാന നിമിഷങ്ങൾക്കായി',
  hmPromoTitle: 'നിങ്ങളുടെ പരിപാടി *ശരിയായ വേദി* അർഹിക്കുന്നു',
  hmPromoBody:
    'വിശാലമായ ബോൾറൂമുകൾ, മനോഹരമായ കല്യാണ മണ്ഡപങ്ങൾ, വലിയ ഓഡിറ്റോറിയങ്ങൾ — ഓരോന്നും ഇരിപ്പിട ശേഷി, നിരക്കുകൾ, ഒഴിവുള്ള തീയതികൾ സഹിതം. എല്ലാം ഒരിടത്ത് താരതമ്യം ചെയ്യൂ, പിന്നെ വേദിയുമായി നേരിട്ട് ദിവസം ഒരുക്കൂ.',
  hmPromoCta: 'എല്ലാ വേദികളും കാണുക',

  // how it works
  hmHowEyebrow: 'പ്രവർത്തന രീതി',
  hmHowNote: 'ഓൺലൈനായി ഒന്നും ഈടാക്കില്ല',
  hmHowTitle: 'തിരയൽ മുതൽ *സ്ഥിരീകരിച്ച തീയതി* വരെ',
  hmHowSub: 'Aghosha-യിലെ ബുക്കിംഗ് ഒരു അഭ്യർത്ഥനയാണ്, പേയ്മെന്റല്ല. വേദി അത് സ്ഥിരീകരിക്കുന്നു, നിങ്ങൾ പണം നേരിട്ട് വേദിക്ക് നൽകുന്നു.',
  hmHowGuide: 'മുഴുവൻ ഗൈഡ് വായിക്കുക',
  hmStepN: 'ഘട്ടം {n}',
  hmStep1Title: 'കണ്ടെത്തുക',
  hmStep1Body: 'സ്ഥലം, അതിഥികളുടെ എണ്ണം, പരിപാടിയുടെ തരം എന്നിവ വെച്ച് തിരയൂ.',
  hmStep2Title: 'താരതമ്യം ചെയ്യുക',
  hmStep2Body: 'ഫോട്ടോകൾ, സൗകര്യങ്ങൾ, നിരക്കുകൾ, ഒഴിവുള്ള തീയതികൾ ഒരുമിച്ച് നോക്കൂ.',
  hmStep3Title: 'അഭ്യർത്ഥിക്കുക',
  hmStep3Body: 'തീയതിയും സെഷനും തിരഞ്ഞെടുത്ത് ബുക്കിംഗ് അഭ്യർത്ഥന അയയ്ക്കൂ. ഓൺലൈനായി ഒന്നും ഈടാക്കില്ല.',
  hmStep4Title: 'സ്ഥിരീകരിക്കുക',
  hmStep4Body: 'വേദി നിങ്ങളുടെ അഭ്യർത്ഥന സ്ഥിരീകരിക്കുന്നു. പണം വേദിയിൽ നേരിട്ട് നൽകാം, ഓരോ വിവരവും അറിയിപ്പായി ലഭിക്കും.',

  // spotlight
  hmSpotEyebrow: 'വേദി ശ്രദ്ധയിൽ',
  hmSpotTitle: 'ഒരു വേദി, *അടുത്തുനിന്ന്*',
  hmSpotReviews: { one: '{count} അവലോകനം', other: '{count} അവലോകനങ്ങൾ' },
  hmSpotNew: 'Aghosha-യിൽ പുതിയത്',
  hmSpotCapacity: 'ശേഷി',
  hmSpotGuests: { one: '{count} അതിഥി', other: '{count} അതിഥികൾ' },
  hmSpotFrom: 'നിരക്ക് തുടങ്ങുന്നത്',
  hmSpotOnRequest: 'നിരക്ക് അന്വേഷിക്കുക',
  hmSpotFacilities: 'സൗകര്യങ്ങൾ',
  hmSpotAc: 'എയർ കണ്ടീഷൻ ചെയ്തത്',
  hmSpotLift: 'ലിഫ്റ്റ് സൗകര്യം',
  hmSpotCarParking: { one: '{count} കാറിന് പാർക്കിംഗ്', other: '{count} കാറുകൾക്ക് പാർക്കിംഗ്' },
  hmSpotParking: 'പാർക്കിംഗ്',
  hmSpotCatering: 'കാറ്ററിംഗ്: {value}',
  hmSpotCta: 'വേദി കാണുക',
  hmSpotPhoto: '{name} — ഫോട്ടോ {n} കാണിക്കുക',

  // locations
  hmLocEyebrow: 'സ്ഥലങ്ങൾ',
  hmLocNote: 'കൂടുതൽ നഗരങ്ങൾ ചേരുന്നു',
  hmLocTitle: 'നഗരം *തിരിച്ച്* വേദികൾ',
  hmLocSub: 'വേദികളുള്ള ഓരോ നഗരവും, അവിടെ എത്ര വേദികൾ ലഭ്യമാണെന്നും.',
  hmLocAll: 'എല്ലാ സ്ഥലങ്ങളും',
  hmLocBrowseTitle: 'എവിടെ എന്ന് ഉറപ്പില്ലേ?',
  hmLocBrowseBody: 'എല്ലാ വേദികളും കാണൂ; തീയതി, അതിഥികൾ, പരിപാടി എന്നിവ വെച്ച് ചുരുക്കൂ.',
  hmLocBrowseCta: 'എല്ലാ വേദികളും കാണുക',

  // event types
  hmEvEyebrow: 'പരിപാടി തരങ്ങൾ',
  hmEvNote: { one: '{count} തരം പരിപാടി', other: '{count} തരം പരിപാടികൾ' },
  hmEvTitle: 'ഓരോ തരം *ആഘോഷത്തിനും* ഇടങ്ങൾ',
  hmEvSub: 'പരിപാടിയുടെ തരം തിരഞ്ഞെടുക്കൂ, അതിന് സാധാരണ ചേരുന്ന വേദികൾ കാണാം.',

  // guides
  hmInspEyebrow: 'പ്രചോദനം',
  hmInspNote: 'പ്രായോഗിക ആസൂത്രണ ഗൈഡുകൾ',
  hmInspTitle: '*ആദ്യ ആശയം മുതൽ* നന്നായി ഒരുക്കാം',
  hmInspSub: 'വേദി തിരഞ്ഞെടുക്കാനും ഒരുക്കാനും ബുക്ക് ചെയ്യാനുമുള്ള പ്രായോഗിക ഗൈഡുകൾ.',
  hmInspAll: 'എല്ലാ ഗൈഡുകളും',
  hmInspRead: 'കൂടുതൽ വായിക്കുക',
  hmInspMins: '{count} മിനിറ്റ് വായന',
  hmCatPlanning: 'ആസൂത്രണം',
  hmCatWeddings: 'വിവാഹം',
  hmCatCorporate: 'കോർപ്പറേറ്റ്',
  hmCatVenues: 'വേദി തിരഞ്ഞെടുക്കൽ',

  // ideas

  // reviews
  hmRevEyebrow: 'അതിഥികളുടെ അവലോകനങ്ങൾ',
  hmRevNote: 'ബുക്ക് ചെയ്ത അതിഥികളിൽ നിന്ന്',
  hmRevTitle: 'പരിപാടി സംഘാടകരുടെ ഇഷ്ടം',
  hmRevSub: 'Aghosha വഴി വേദി ബുക്ക് ചെയ്ത അതിഥികൾക്ക് മാത്രമേ അതിന് അവലോകനം എഴുതാനാകൂ.',
  hmRevRated: '5-ൽ {rating} റേറ്റിംഗ്',
  hmRevBooked: 'ബുക്ക് ചെയ്തത്:',
  hmRevShow: '{total}-ൽ {n}-ാം അവലോകനം കാണിക്കുക',

  // numbers
  hmFigEyebrow: 'Aghosha അക്കങ്ങളിൽ',
  hmFigNote: 'വേദികൾ ചേരുന്തോറും വളരുന്നു',
  hmFigTitle: 'വളരുന്ന *വേദി ശൃംഖല*',
  hmFigVenues: { one: 'ലിസ്റ്റ് ചെയ്ത വേദി', other: 'ലിസ്റ്റ് ചെയ്ത വേദികൾ' },
  hmFigVenuesNote: 'പ്രസിദ്ധീകരിക്കും മുൻപ് പരിശോധിച്ചത്',
  hmFigCities: { one: 'നഗരം', other: 'നഗരങ്ങൾ' },
  hmFigCitiesNote: 'കൂടുതൽ നഗരങ്ങൾ ചേരുന്നു',
  hmFigEvents: { one: 'സ്ഥിരീകരിച്ച പരിപാടി', other: 'സ്ഥിരീകരിച്ച പരിപാടികൾ' },
  hmFigEventsNote: 'വേദികൾ സ്ഥിരീകരിച്ച അഭ്യർത്ഥനകൾ',
  hmFigRating: 'ശരാശരി അതിഥി റേറ്റിംഗ്',
  hmFigRatingNote: { one: '{count} അവലോകനത്തിൽ നിന്ന്', other: '{count} അവലോകനങ്ങളിൽ നിന്ന്' },

  // ring call to action (the ring text stays in English, like the logo)
  hmFinalEyebrow: 'ആസൂത്രണം തുടങ്ങൂ',
  hmRingText: 'സ്ഥലം കണ്ടെത്തൂ  ✦  നിമിഷം ഒരുക്കൂ  ✦  ',
  hmFinalTitle: 'നിങ്ങളുടെ *വേദി* കണ്ടെത്താൻ തയ്യാറാണോ?',
  hmFinalBody: 'നഗരം, തീയതി, അതിഥികളുടെ എണ്ണം എന്നിവ നൽകി തിരയൂ, പിന്നെ വേദിക്ക് അഭ്യർത്ഥന അയയ്ക്കൂ. ഓൺലൈനായി പണമൊന്നും നൽകേണ്ട.',
  hmFinalExplore: 'വേദികൾ കാണുക',
  hmFinalList: 'നിങ്ങളുടെ വേദി ലിസ്റ്റ് ചെയ്യൂ',
};
